import { useAppDispatch } from "../../../State/Store";
import { CartItem } from "../../../types/cartTypes";
import { Add, Close, Remove } from "@mui/icons-material";
import { Button, Divider, IconButton } from "@mui/material";
import React from "react";
import { deleteCartItem, updateCartItem } from "../../../State/customer/cartSlice";

const FALLBACK_IMAGE =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTctl02UiSUqaJlEHt9du_AiYsMlg_Uq4t0eQ&s";

const CartItemCard = ({ item }: { item: CartItem }) => {
    const dispatch = useAppDispatch();

    const handleUpdateQuantity = (value: number) => () => {
        if (item.quantity + value < 1) return;

        const itemId = item.id ?? item.product?.id ?? 0;

        dispatch(updateCartItem({
            jwt: localStorage.getItem("jwt"),
            cartItemId: itemId,
            cartItem: { quantity: item.quantity + value }
        }));
    };

    const handleRemoveItem = () => {
        const itemId = item.id ?? item.product?.id ?? 0;

        dispatch(deleteCartItem({
            jwt: localStorage.getItem("jwt") || "",
            cartItemId: itemId
        }));
    };

    // Safe extraction of product properties with fallbacks
    const imageUrl = item.product?.images?.[0] || FALLBACK_IMAGE;
    const title = item.product?.title || "Product";
    const description = item.product?.description || "";
    const sellerName = item.product?.seller?.businessDetails?.businessName || "Official Store";

    return (
        <div className='border rounded-md relative'>
            <div className='p-5 flex gap-3'>
                <div>
                    <img
                        className='w-[90px] h-[90px] object-cover rounded-md'
                        src={imageUrl}
                        alt={title}
                    />
                </div>

                <div className='space-y-2'>
                    <h1 className='font-semibold text-lg'>
                        {title}
                    </h1>
                    
                    <p className='text-gray-400 text-xs'>
                        <strong>Sold by: </strong>{sellerName}
                    </p>
                    <p className='text-sm'>7 Days replacement available</p>
                    <p className='text-sm text-gray-500'>
                        <strong>Quantity: </strong>{item.quantity}
                    </p>
                </div>
            </div>

            <Divider />

            <div className='flex justify-between items-center'>
                <div className='px-5 py-2 flex justify-between items-center'>
                    <div className='flex items-center gap-2 w-[140px] justify-between'>
                        <Button
                            onClick={handleUpdateQuantity(-1)}
                            disabled={item.quantity <= 1}
                        >
                            <Remove />
                        </Button>
                        <span>
                            {item.quantity}
                        </span>
                        <Button onClick={handleUpdateQuantity(1)}>
                            <Add />
                        </Button>
                    </div>
                </div>

                <div className='pr-5'>
                    <p className='text-gray-700 font-medium'>
                        Ksh {((item.sellingPrice || item.product?.sellingPrice || 0) * item.quantity).toLocaleString()}
                    </p>
                </div>
            </div>

            <div className='absolute top-1 right-1'>
                <IconButton onClick={handleRemoveItem} color="primary">
                    <Close />
                </IconButton>
            </div>
        </div>
    );
};

export default CartItemCard;